<template>

    <div class="outer-wrap">

            <div class="merchants-list">
                <!--<img :src="'../../../../img/logo.png'" class="merchants-logo-xo"/>-->
                <p class="merchants-title">Welcome to Express Orders</p>
                <p class="merchants-subtitle">Select a restaurant to start ordering now</p>

                <div  v-for=" ( merchant, merKey ) in allMerchants " :key=" merKey ">


                    <div :class=" merchantClasses( merchant ) " @click=" passToOrder( merchant ) " v-if=" merchant.quickOrder == 1 ">
                            <div>

                                <img :src=" merchant.slug ? getLogoMerchantUrl( merchant.merchantId ) : '../../img/expressorders/logo.jpg' " class="merchant-image" @error="imageLoadError" alt=""/>
                            </div>

                            <p class="merchant-name">{{ merchant.name }}</p>

                    </div>

                </div>

            </div>

    </div>
    
</template>

<script>

    import { mapGetters } from 'vuex';

    export default {

        name : 'not-found',
        computed: {

            ...mapGetters({

                allMerchants            : 'orderMenu/allMerchants',
                imageUrl                : 'imageUrl',
                isLoading               : 'isLoading',
                phoneUser               : 'auth/phoneUser',
                authViaPhone            : 'auth/authViaPhone',
                allMerchantsWithImages  : 'merchant/allMerchantsWithImages'
            })
        },
        methods: {

            selectMerchant( merchant ){

                console.log( 'selecting merchant ' );

                this.$router.push({

                    name: 'signin',
                    params : { slug : merchant.slug }
                });
                
            },
            passToOrder(merchant){
                console.log('Merchant: ==> ', merchant);
                console.log('flat authViaPhone true or false: ', this.authViaPhone);

                const data = {

                    merchantId  : merchant.merchantId,
                    phone : this.phoneUser
                };
                if ( data.phone == null || this.authViaPhone ) {
                    
                    const outCredentials = {

                        merchantId  : merchant.merchantId,
                        slug : merchant.slug,
                        name : merchant.name 
                    };
                    this.$store.dispatch('auth/outAuthMerchantCredentials', outCredentials);
                    
                    /*
                    this.$router.push({

                        name: 'signin',
                        params : { slug : merchant.slug }
                    });
                    */
                } else {
                    this.$store.dispatch( 'auth/getMerchantCredentials', data );
                }

                this.$store.dispatch( 'orders/generateUuidOrder' ).then( uuidOrder => {
                    console.log(uuidOrder);

                    const order = {
                        uuid: uuidOrder,
                        deliveryFee: 0
                    };

                    this.$store.dispatch( 'orders/setActiveOrder', order );
                });
            },
            merchantClasses( merchant ){

                const base = [ 'merchant-tab' ];
                base.push( '' )
                return base.join( ' ' );
            },
            getLogoMerchantUrl( merchantId ){
                var urlImagesFromStaticRealPayment = '';
                const merchantsLogos = this.allMerchantsWithImages;
                merchantsLogos.forEach( merchantLogo => {
                    if (merchantLogo.merchantId == merchantId) {
                        urlImagesFromStaticRealPayment = merchantLogo.imagePath + merchantLogo.imageName;
                    }     
                });

                return this.imageUrl + urlImagesFromStaticRealPayment
            },
            imageLoadError(event){
                console.log('Error Image');
                event.target.src = '../../img/expressorders/logo.jpg'
            }
        },
        created(){
            // might be redundant, but if we get here may as well clear app state because we shouldn't get here at all

            console.log( 'created!' );
            this.$store.dispatch( 'clearIndexDb' );
            this.$store.dispatch( 'nav/setHeaderClosed' );
            this.$store.dispatch( 'orderMenu/grabAllMerchants' );
            this.$store.dispatch( 'merchant/getQuickOrderMerchants' );
        }
    }
</script>

<style scoped>

    .merchants-list {

        position: relative;
    }

    .outer-wrap {

        margin: 0px auto;
        width: 100%;
        max-width: 500px;
    }

    .merchant-tab {

        display: flex;
        align-items: center;
        justify-content: flex-start;
        position: relative;

        background-color: white;
        margin-bottom: 10px;
        margin-top: 10px;

        box-shadow: 0px 3px 8px 0px rgba( 0, 0, 0, 0.5 );

        width: 100%;
        height: 100px;
    }

    .merchant-tab > * {

        cursor: pointer;
        user-select: none;
    }

    .merchant-name {

        margin: 0;
        font-size: 1.3rem;
        padding: 5px 0px 0px 15px;
        width: 100%;
        height: 60px;
    }
    .merchant-image {

        position: relative;
        left: 10px;
        max-width: 100px;
        max-height: 80px;
    }

    .merchants-title {

        text-align: center;
        font-size: 28px;
        font-weight: bold;
        margin-bottom: 20px;
        margin-top: 20px;
        color: #e10b00;
    }

    .merchants-logo-xo {
        display: block;
        margin-left: auto;
        margin-right: auto;
        width: 50%;
    }

    .merchants-subtitle {

        text-align: center;
        font-size: 16px;
    }

</style>
